import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodSpaceFragment } from '@api/fragments'
import { INeighborhoodSpace } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteSpacesFromWorkplaceGroup: {
    spaces: INeighborhoodSpace[]
  }
}

const mutateHandler = handleFetchResult<IPayload, INeighborhoodSpace[]>({
  handler: (data) => data.deleteSpacesFromWorkplaceGroup.spaces,
  name: 'Spaces',
})

export const removeSpacesFromWorkplaceGroupMutation = gql`
  mutation DeleteSpacesFromWorkplaceGroup($input: DeleteSpacesFromWorkplaceGroupInput!) {
    deleteSpacesFromWorkplaceGroup(input: $input) {
      spaces {
        ...NeighborhoodSpaceFragment
      }
    }
  }
  ${NeighborhoodSpaceFragment}
`

export default function removeSpacesFromWorkplaceGroup(
  spaceIds: string[],
  workplaceGroupId?: string
): Promise<INeighborhoodSpace[]> {
  const input = { spaceIds, workplaceGroupId }

  return client.gql
    .mutate({
      mutation: removeSpacesFromWorkplaceGroupMutation,
      variables: { input },
    })
    .then(mutateHandler)
}
